import { mapGetters } from "vuex"

export default {
  methods: {
    jumpArticle(articleInfo) {
      if (this.systemInfo.isNfPlus && articleInfo.jumpUrl) {
        window.location.href = articleInfo.jumpUrl
      } else {
        window.location.href = articleInfo.shareUrl
      }
    }
  },
  computed: {
    ...mapGetters({
      systemInfo: "systemInfo"
    })
  }
}
